export const OC_QUICK_ORDER_LOADER = {
  desktop: `<div class="cui cui-grid cui-container">
  <div class="cui-row -spacing--top-96">
    <div class="cui-col-xl-10 cui-col-md-10">
      <div class="cui-skeleton-heading -size--large -spacing--bottom-120 -spacing--top-8 -resolution--desktop">
        <div class="cui-skeleton-heading__content -spacing--bottom-40" style="width: 80%">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
        <div class="cui-skeleton-paragraph__content -spacing--bottom-40 " style="width: 80%">
          <div class="cui-skeleton__item" style="height: 50px"></div>
        </div>
        <div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80">
            <div class="cui-skeleton__item" style="width: 80%; height: 100px"></div>
          </div>
        </div>
        <div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80">
            <div class="cui-skeleton__item" style="width: 80%; height: 400px"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="cui-col-xl-2 cui-col-md-2">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-40 -spacing--top-80">
        <div class="cui-skeleton__item" style="width: 100%; height: 120px"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-8">
        <div class="cui-skeleton__item" style="width: 100%; height: 120px"></div>
      </div>
    </div>
  </div>`
};
